import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { APP_CONFIG, Configuration } from '@content-platform/web-angular-shared-util-configuration';
import * as environment from './environments/environment';

Configuration.load('/config.json', 'home', { version: environment.version }).then(config => {
  if (environment.production && Configuration.isProductionEquivalentEnvironment()) {
    enableProdMode();
  }

  platformBrowserDynamic([
    {
      provide: APP_CONFIG,
      useValue: config
    }
  ])
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));
});
